// TwoKeyBanner (Parte 14.2): estado "aguardando segunda chave" com quem já assinou e o prazo.
import { Alert, AlertDescription, AlertTitle } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

export interface TwoKeyBannerProps {
  readonly firstKeyBy: string;
  /** Instante já formatado para exibição (useDateFormatter). */
  readonly firstKeyAt: string;
  readonly deadline?: string | null;
}

export function TwoKeyBanner({ firstKeyBy, firstKeyAt, deadline }: TwoKeyBannerProps) {
  const { t } = useTranslation('common');
  return (
    <Alert role="status" data-testid="two-key-banner">
      <AlertTitle>{t('components.twoKey.title')}</AlertTitle>
      <AlertDescription>
        <p>{t('components.twoKey.firstKey', { name: firstKeyBy, when: firstKeyAt })}</p>
        <p>
          {deadline
            ? t('components.twoKey.deadline', { when: deadline })
            : t('components.twoKey.noDeadline')}
        </p>
      </AlertDescription>
    </Alert>
  );
}
